module.exports = __webpack_public_path__ + "img/active-a.0127f911.png";